import React from 'react';
import {withStyles} from '@material-ui/core/styles'
import {CircularProgress} from "@material-ui/core";

const styles = {
  loader:{
    margin: 'auto',
    width:'75px !important',
    height: '75px !important',
    opacity:'0.85 !important',
    animationDuration: '4000ms',
    '& > svg': {
      overflow: "visible",
      '& > circle': {
        animationDuration: '4000ms',
      },
    }
  },
  loaderSm:{
    margin: 'auto',
    width:'28px !important',
    height: '28px !important',
    opacity:'0.85 !important',
    animationDuration: '4000ms',
    '& > svg': {
      overflow: "visible",
      '& > circle': {
        animationDuration: '4000ms',
        strokeWidth: '0.5rem'
      },
    }
  },
  loaderXs:{
    margin: 'auto',
    width:'1rem !important',
    height: '1rem !important',
    padding: '2px',
    opacity:'0.85 !important',
    animationDuration: '4000ms',
    '& > svg': {
      overflow: "visible",
      '& > circle': {
        animationDuration: '4000ms',
        // strokeWidth:'0.5rem'
      },
    }
  },
  loaderFs:{
    margin: 'auto',
    width:'1em !important',
    height: '1em !important',
    padding: '2px',
    opacity:'0.85 !important',
    boxSizing:"border-box",
    animationDuration: '4000ms',
    '& > svg': {
      overflow: "visible",
      '& > circle': {
        animationDuration: '4000ms',
        strokeWidth: 'calc(min(0.5rem, 0.5em))'
      },
    }
  }
};

function LoadingCircle({children, className='', size, classes, ...divProps}) {
  return (
    <CircularProgress
      // style={size === "sm" ? {width:'28px !important', height: '28px !important', opacity:'0.85 !important'} : {width:'75px', height: '75px', opacity:0.85}}
      color="secondary"
      variant="indeterminate"
      className={`${className} ${size === "sm" ? classes.loaderSm : size === "xs" ? classes.loaderXs : size === "font" ? classes.loaderFs : classes.loader}`}
      {...divProps}
    >
      {children}
    </CircularProgress>);
};

export default withStyles(styles)(LoadingCircle);
